
/* eslint-disable @typescript-eslint/camelcase */
import { PropType } from "vue";
import { Options, Vue, prop } from "vue-class-component";
import SelectSearch from "@/app/ui/components/select-search-origin-destination/index.vue";
import SelectSearchV2 from "@/app/ui/components/select-search/index.vue";
import InputDimension from "@/app/ui/components/input-dimension/index.vue";
import InputAdornment from "./check-tariff-input-adorment.vue";
import PillSwitch from "@/app/ui/components/pill-switch/index.vue";
import debounce from "lodash/debounce";
import { ClientController } from "@/app/ui/controllers/ClientController";
import { CommodityController } from "@/app/ui/controllers/CommodityController";
import { SHIPMENT_CEK_TARIF } from "@/app/infrastructures/misc/RolePermission";
import { AccountController } from "@/app/ui/controllers/AccountController";
import {
  checkRolePermission,
  formatInputMoney,
  formatInputNumberOnlyV2,
  IS_SENDER_ACCOUNT,
  parseInputFloatToFloat
} from "@/app/infrastructures/misc/Utils";
import { RequestListCommodity } from "@/data/payload/api/CommodityApiRequest";
import { TariffController } from "@/app/ui/controllers/TariffController";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { Commodity } from "@/domain/entities/Commodity";
import {
  MAX_WEIGHT_TARIFF_GR,
  MAX_WEIGHT_TARIFF_KG
} from "@/app/infrastructures/misc/Constants";
import {
  formatInputByCountry,
  parseByCountry
} from "@/app/infrastructures/misc/Utils";

class Props {
  isLoadin = prop<boolean>({
    default: false,
    type: Boolean
  });
  isDisabled = prop<boolean>({
    default: true,
    type: Boolean
  });
  isReset = prop<boolean>({
    default: false,
    type: Boolean
  });
  labelButtonRight = prop<string>({
    default: "Download Tarif",
    type: String
  });
  // origin
  placeholderOrigin = prop<string>({
    default: "",
    type: String
  });
  searchValueOrigin = prop<string>({
    default: "",
    type: String
  });
  selectSearchDataOrigin = prop<any[]>({
    default: [],
    type: Array
  });
  onSelectSearchOrigin = prop<Function>({
    default: Function as PropType<() => void>,
    type: Function
  });
  onOpenSelectSearchOrigin = prop<Function>({
    default: Function as PropType<() => void>,
    type: Function
  });
  onCloseSelectSearchOrigin = prop<Function>({
    default: Function as PropType<() => void>,
    type: Function
  });
  onChooseSelectSearchOrigin = prop<Function>({
    default: Function as PropType<() => void>,
    type: Function
  });
  statusSelectSearchOrigin = prop<boolean>({
    default: false,
    type: Boolean
  });
  selectSearchOriginNotFound = prop<boolean>({
    default: false,
    type: Boolean
  });
  // destination
  placeholderDestination = prop<string>({
    default: "",
    type: String
  });
  searchValueDestination = prop<string>({
    default: "",
    type: String
  });
  selectSearchDataDestination = prop<any[]>({
    default: [],
    type: Array
  });
  onSelectSearchDestination = prop<Function>({
    default: Function as PropType<() => void>,
    type: Function
  });
  onOpenSelectSearchDestination = prop<Function>({
    default: Function as PropType<() => void>,
    type: Function
  });
  onCloseSelectSearchDestination = prop<Function>({
    default: Function as PropType<() => void>,
    type: Function
  });
  onChooseSelectSearchDestination = prop<Function>({
    default: Function as PropType<() => void>,
    type: Function
  });
  statusSelectSearchDestination = prop<boolean>({
    default: false,
    type: Boolean
  });
  selectSearchDestinationNotFound = prop<boolean>({
    default: false,
    type: Boolean
  });
  // product
  valueProduct = prop<string>({
    default: "",
    type: String
  });
  productSelect = prop<boolean>({
    default: false,
    type: Boolean
  });
  productData = prop<any[]>({
    default: [{ name: "", value: "" }],
    type: Array
  });
  onOpenProductSelect = prop<Function>({
    default: Function as PropType<() => void>,
    type: Function
  });
  onCloseProductSelect = prop<Function>({
    default: Function as PropType<() => void>,
    type: Function
  });
  onSelectProduct = prop<Function>({
    default: Function as PropType<() => void>,
    type: Function
  });
  // client
  clientValue = prop<string>({
    default: ""
  });
  // commodity
  valueCommodity = prop<string>({
    default: ""
  });
  // berat/paket
  weight = prop<string>({
    default: ""
  });
  weightUnit = prop<"kg" | "gr">({
    default: "kg"
  });
  // dimension
  length = prop<string>({
    default: ""
  });
  width = prop<string>({
    default: ""
  });
  height = prop<string>({
    default: ""
  });
  price = prop<string>({
    default: ""
  });
}
@Options({
  components: {
    SelectSearch,
    InputDimension,
    InputAdornment,
    SelectSearchV2,
    PillSwitch
  },
  emits: ["onButtonRight", "filter", "reset", "onToggleShowFilter", "update:weightUnit"]
})
export default class Header extends Vue.with(Props) {
  isScreenMD = true;
  dataListCommodities: Commodity[] = [];

  get countryCode() {
    const code = AccountController.accountData?.countryCode;
    return code?.toUpperCase() ?? "ID";
  }
  get hasSlotData() {
    return !!this.$slots.default;
  }

  get detailDistrict() {
    return LocationController.districtDetailTariff;
  }

  get isInternal() {
    return AccountController.accountData.isInternalAccount;
  }

  get isSenderAccount() {
    return IS_SENDER_ACCOUNT;
  }

  get isPosAccount() {
    return AccountController.accountData.isPosAccount;
  }

  get accountCurrency() {
    return AccountController.accountData?.account_location?.country_currency || "IDR"
  }

  get isAccountCountryOutsideID() {
    return (
      AccountController.accountData.account_type_detail.countryCode.toLowerCase() !==
      "id"
    );
  }

  // permission
  get isFilterAble() {
    return checkRolePermission(SHIPMENT_CEK_TARIF.FILTER);
  }
  get isShowListClient() {
    if (AccountController.accountData.account_type.toLowerCase() === "client") {
      this.form.client =
        AccountController.accountData.account_type_detail.company_name;
      return true;
    }
    return false;
  }

  mounted() {
    this.syncFormFromProps();
    this.checkScreenSize();
    this.$emit("onToggleShowFilter", this.isFilterShow);
    window.addEventListener("resize", this.checkScreenSize);
  }

  syncFormFromProps() {
    (["length", "width", "height", "weight"] as const).forEach((key) => {
      const val = this[key];
      if (val !== undefined && val !== "")
        this.form[key] = Number(val) || this.form[key];
    });
    if (this.price !== undefined && this.price !== "")
      this.form.price = String(this.price);
  }

  checkScreenSize() {
    // Cek ukuran layar saat ini
    if (window.innerWidth >= 768) {
      // Jika layar lebih besar dari 768px (breakpoint md di Tailwind)
      this.isScreenMD = true;
    } else {
      // Jika layar lebih kecil dari 768px
      this.isScreenMD = false;
    }
  }

  // client/partner
  onChangeClient(value: any) {
    this.form.client = value;
    this.$emit("update:clientValue", value);
  }
  onGetListPartner(search: string) {
    ClientController._onGetListPartner({
      page: 1,
      limit: 10,
      search: search,
      partnerType: "client"
    });
  }

  fetchClientPartner = debounce((search: string) => {
    this.onGetListPartner(search);
  }, 250);

  get clientPartnerData() {
    return ClientController.clientPartnerData;
  }

  get isLoadingClientPartner() {
    return ClientController.isLoading;
  }

  get isInternalOutsideID() {
    return (
      this.isInternal && this.detailDistrict.countryCode.toLowerCase() === "my"
    );
  }

  // commodity
  commodityValueSearch = "";
  onChangeCommodity(value: any) {
    this.form.commodity = value;
    this.$emit("update:valueCommodity", value.commodity_id);
  }
  async onGetCommodityList(search: string) {
    const commodities = await CommodityController.getCommodityList(
      new RequestListCommodity({
        search: search,
        page: 1,
        limit: 20,
        commodityStatus: "active"
      })
    );
    this.dataListCommodities = commodities.data;
  }
  fetchCommodity = debounce((search: string) => {
    this.commodityValueSearch = search;
    this.onGetCommodityList(search);
  }, 250);

  async fetchCommodityListInfiniteScroll(search = "") {
    CommodityController.commodities.pagination.page++;
    const commodities = await CommodityController.getCommodityList(
      new RequestListCommodity({
        search,
        page: CommodityController.commodities.pagination.page,
        limit: 20,
        commodityStatus: "active"
      })
    );
    this.dataListCommodities.push(...commodities.data);
  }

  get commodityList() {
    const data = this.dataListCommodities
      .filter((key) =>
        this.isAccountCountryOutsideID ||
        (this.isInternalOutsideID && this.searchValueOrigin)
          ? !!key.commodity_name_en
          : true
      )
      .map((key) => ({
        ...key,
        commodity_name:
          this.isAccountCountryOutsideID ||
          (this.isInternalOutsideID && this.searchValueOrigin)
            ? key.commodity_name_en
            : key.commodity_name
      }));
    if (this.commodityValueSearch) return data;
    else
      return [
        { commodity_name: "All Commodity", commodity_id: "all" },
        ...data
      ];
  }

  get loadingCommodity() {
    return CommodityController.isLoading;
  }

  // current routes
  get currentRoutes() {
    return this.$route?.meta.name;
  }

  // show filter
  isFilterShow = true;
  setFilterShow(value: boolean) {
    this.isFilterShow = value;
    this.$emit("onToggleShowFilter", value);
  }

  get commodityGeneralOthersId() {
    return FlagsMedusa.config_commodity_general_others_id.getValue();
  }

  get commodityGeneralOthersName() {
    return FlagsMedusa.config_commodity_general_others_name.getValue();
  }
  // misc variable
  form = {
    client: "",
    commodity: {
      commodity_name: this.commodityGeneralOthersName,
      commodity_id: this.commodityGeneralOthersId
    },
    weight: 1,
    length: 30,
    width: 20,
    height: 10,
    price: ""
  };

  // format input price
  formatInputPrice(value: string) {
    return formatInputByCountry(value, {
      type: "money",
      country: this.countryCode
    });
  }

  onChangePrice(value: string) {
    this.$emit("update:price", value);
  }

  // weight
  onChangeWeight(value: any) {
    this.$emit("update:weight", value);
  }

  weightUnitOptions = [
    { label: "kg", value: "kg" },
    { label: "gr", value: "gr" }
  ];

  setWeightUnit(unit: "kg" | "gr") {
    this.$emit("update:weightUnit", unit);
  }

  get isWeightError(): boolean {
    if (this.weightUnit === "gr") {
      return (
        parseByCountry(this.form.weight, { country: this.countryCode }) >
        MAX_WEIGHT_TARIFF_GR
      );
    }
    return (
      parseByCountry(this.form.weight, { country: this.countryCode }) >
      MAX_WEIGHT_TARIFF_KG
    );
  }

  get weightErrorCaption(): string {
    const base = this.$t("shipmentRates.errorMaximalWeight").toString();
    if (this.weightUnit === "gr") {
      const formatted =
        this.$i18n.locale === "id"
          ? MAX_WEIGHT_TARIFF_GR.toLocaleString("id-ID")
          : MAX_WEIGHT_TARIFF_GR.toLocaleString(this.$i18n.locale);
      return `${base} ${formatted} Gr`;
    }
    return `${base} ${MAX_WEIGHT_TARIFF_KG} Kg`;
  }

  // dimension
  onChangeDimension({ length, width, height }: any) {
    this.$emit("update:length", length);
    this.$emit("update:width", width);
    this.$emit("update:height", height);
  }

  onReset() {
    this.$emit("reset");
  }

  get isLoading() {
    return TariffController.isLoading;
  }
  onFilter() {
    this.$emit("filter");
  }

  onButtonRight() {
    this.$emit("onButtonRight");
  }
}
